// extracted by mini-css-extract-plugin
export default {"sec_heading":"Groups_sec_heading__5L0qw","wraper":"Groups_wraper__SDGDQ"};